<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else-if="emptyState">
      <div class="text-center">
        <p>
          <font-awesome-icon
            :icon="['fas', 'folder-open']"
            style="margin-right: 20px; font-size: 35px;"
          />
        </p>
        <h5>
          {{ this.$t('reports.monthlyDetractors.noDataLabel') }}
        </h5>
        <p>
          {{ this.$t('reports.monthlyDetractors.noDataMsg') }}
        </p>
      </div>
    </div>
    <div v-else class="px-3">
      <highcharts :options="chartOptions"></highcharts>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

export default {
  name: 'MonthlyDetractorsReport',

  data: () => ({
    loading: false,
    loadingTable: false,
    emptyState: false,
    userAuth: null,
    chartOptions: {},
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'myActionsIds', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.loadChart();
    },

    myActionId: function watchmyActionId() {
      this.loadChart();
    },

    myActionsIds: function watchmyActionsIds() {
      this.loadChart();
    },

    calendarDates: function watchCalendarDates() {
      this.loadChart();
    },

    myIh1: function watchMyIh1() {
      this.loadChart();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.loadChart();
    },

    myIh2: function watchMyIh2() {
      this.loadChart();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.loadChart();
    },

    myMetric: function watchMyMetric() {
      this.loadChart();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.loadChart();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.loadChart();
    },
  },

  methods: {
    getMonthName(month) {
      // eslint-disable-next-line
      const monthNames = this.$i18n.messages[this.$i18n.locale].reports.fullMonthNames;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < monthNames.length; i++) {
        if (monthNames[i].key.toLowerCase() === month.toLowerCase()) {
          return monthNames[i].value;
        }
      }
      return null;
    },
    async loadChart() {
      this.loading = true;
      this.emptyState = false;

      const response = await api.get('/reports/monthly-detractors', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      if (response.data.length === 0) {
        this.emptyState = true;
      }

      this.chartOptions.xAxis.categories = [];
      this.chartOptions.series[0].data = [];
      this.comparingAnswers = [];

      response.data.forEach((month) => {
        this.chartOptions.xAxis.categories.push(this.getMonthName(month.name));

        this.chartOptions.series[0].data.push({
          y: month.total,
          answers: month.answers,
        });
      });

      this.loading = false;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.chartOptions = {
      title: {
        text: this.$t('reports.monthlyDetractors.chartTitle'),
      },
      chart: {
        type: 'column',
      },
      xAxis: {
        categories: [],
        labels: {},
      },
      yAxis: {
        min: 0,
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
        title: {
          text: '',
        },
      },
      series: [
        {
          name: this.$t('reports.monthlyDetractors.chartSeries'),
          data: [],
          label: true,
          cursor: 'pointer',
          point: {
            events: {
              click: null,
            },
          },
        },
      ],
      colors: ['red'],
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
          },
        },
      },
    };
  },

  async mounted() {
    this.loading = true;
    await this.loadChart();
    this.loading = false;
  },

  beforeDestroy() {
    EventBus.$off('switch-chart');
    EventBus.$off('data-source');
    EventBus.$off('accumulated-report');
  },
};
</script>

<style>
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detractor-review {
  display: flex;
  justify-content: center;
  align-items: center;

  background: red;
  color: white;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/monthly-detractors-report/index.vue